<template>
  <div class="stock-info transfer__wrapper">
    <form-layout
      :main-title="$t('superPass.purchase.title')"
      :small-title="true"
      :title="$t('superPass.stockInfo.title')"
      :hide-footer="true"
    >
      <div class="transfer__form">
        <div class="transfer__form-body">
          <div class="transfer__form-cover">
            <img src="./images/placeholder_img.svg" alt="cover" />
          </div>
          <div class="transfer__form-description" v-html="$t('superPass.stockInfo.description')" />
        </div>
        <div class="transfer__form-footer">
          <Button class="transfer__form-btn" @click="close">
            {{ $t('superPass.stockInfo.ok') }}
          </Button>
        </div>
      </div>
    </form-layout>
  </div>
</template>

<script>
import './superPassStockInfo.scss'

import FormLayout from '@/components/Base/FormLayout/FormLayout.vue'
import Button from '@/components/Base/Button/Button.vue'

export default {
  name: 'SuperPassStockInfo',
  components: {
    FormLayout,
    Button
  },
  methods: {
    close() {
      this.$router.push('/')
    }
  }
}
</script>
